import React from "react";

import Video from "./components/Video/Video";

import Logo from "./img/icon.png";

import Vid1 from "./videos/vid1.mp4";
import Vid2 from "./videos/vid2.mp4";
import Vid3 from "./videos/vid3.mp4";
import Vid4 from "./videos/vid4.mp4";
import Vid5 from "./videos/vid5.mp4";
import Vid6 from "./videos/vid6.mp4";
import Vid7 from "./videos/vid7.mp4";
import Vid8 from "./videos/vid8.mp4";
import Vid9 from "./videos/vid9.mp4";
import Vid10 from "./videos/vid10.mp4";
import Vid11 from "./videos/vid11.mp4";
import Vid12 from "./videos/vid12.mp4";
import Vid13 from "./videos/vid13.mp4";


 
import "./App.css";

export default function App() {
  const data = [
    {
      channel: "aaa",
      song: "song-1",
      url: Vid1,
      likes: "32",
      comment: "2",
      shares: "23",
    },
    {
      channel: "bbb",
      song: "song-2",
      url: Vid2,
      likes: "3",
      comment: "22",
      shares: "23",
    },
    {
      channel: "ccc",
      song: "song-3",
      url: Vid3,
      likes: "89",
      comment: "23",
      shares: "29",
    },
    {
      channel: "ccc",
      song: "song-3",
      url: Vid4,
      likes: "89",
      comment: "23",
      shares: "29",
    },
    {
      channel: "ccc",
      song: "song-3",
      url: Vid5,
      likes: "89",
      comment: "23",
      shares: "29",
    },
    {
      channel: "ccc",
      song: "song-3",
      url: Vid6,
      likes: "89",
      comment: "23",
      shares: "29",
    },
    {
      channel: "ccc",
      song: "song-3",
      url: Vid7,
      likes: "89",
      comment: "23",
      shares: "29",
    },
    {
      channel: "ccc",
      song: "song-3",
      url: Vid8,
      likes: "89",
      comment: "23",
      shares: "29",
    },
    {
      channel: "ccc",
      song: "song-3",
      url: Vid9,
      likes: "89",
      comment: "23",
      shares: "29",
    },
    {
      channel: "ccc",
      song: "song-3",
      url: Vid10,
      likes: "89",
      comment: "23",
      shares: "29",
    },
    {
      channel: "ccc",
      song: "song-3",
      url: Vid11,
      likes: "89",
      comment: "23",
      shares: "29",
    },
    {
      channel: "ccc",
      song: "song-3",
      url: Vid12,
      likes: "89",
      comment: "23",
      shares: "29",
    },
    {
      channel: "ccc",
      song: "song-3",
      url: Vid13,
      likes: "89",
      comment: "23",
      shares: "29",
    },
    
  ];

  return (
    <div className="App">
      <center>
        <div className="logo">
          <img alt="logo" src={Logo} className="insta-logo" />
        </div>
        <h3>Rahul Plays</h3>
        {/*  */}

        <div className="video-container" id="video-container">
          {/*  */}

          {data.map((list, i) => (
            <Video
              key={i}
              channel={list.channel}
              song={list.song}
              url={list.url}
              likes={list.likes}
              comment={list.comment}
              shares={list.shares}
            />
          ))}

          {/*  */}
        </div>
      </center>
    </div>
  );
}